import { ProspectoCab } from './../../../models/ProspectoCab';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {  FormGroup, FormBuilder } from '@angular/forms';
import { ObservacionesRespuestaFormat } from 'app/models/ObservacionesRespuestaFormat';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-prospectos-detalle',
  templateUrl: './prospectos-detalle.component.html',
  styleUrls: ['./prospectos-detalle.component.scss']
})
export class ProspectosDetalleComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;
  
  @Input() prospecto: ProspectoCab;
  @Output() cerrarProspectoDetalle: EventEmitter<boolean>;
  titulo: string = "Respuesta del "+this.Label_Prospecto.toLowerCase();
  user: any;
  formularioProspecto: FormGroup;
  observacionesArray: any[] = [];
  observacionesArrayFormat: ObservacionesRespuestaFormat;
  observacionesFinal: any[] = [];




  constructor(
    private formBuilder: FormBuilder
  ) {
    this.cerrarProspectoDetalle = new EventEmitter();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.formularioProspecto = this.formBuilder.group({
      idProspectoCab: 0,
      Ruc_Adquirente: '',
      Ruc_Proveedor: '',
      Tipo_Documento: '',
      Moneda: '',
      Monto_Comercial: 0.00,
      Observaciones_Riesgo: '',
      Estado: '',
      Fecha_Registro: '',
      Alta_Usuario_Comercial: '',
      Correo_Usuario_Comercial: '',
      Nombre_Usuario_Comercial: '',
      Nombre_Usuario_Riesgo: ''
    });

    this.formularioProspecto.disable();
  }

  ngOnInit() {
    if (this.prospecto.Observaciones_Riesgo) {
      if (this.prospecto.Observaciones_Riesgo.includes("|")) {
        this.observacionesArray = this.prospecto.Observaciones_Riesgo.split("|");
        this.observacionesArray.reverse();
      } else {
        this.observacionesArray[0] = this.prospecto.Observaciones_Riesgo;
      }

      for(let value of this.observacionesArray){
        let cadenaFecha = value.split(",")[0]; // Cadena de fecha hasta la coma (,)
        let cadenaParcial = value.slice(value.indexOf(',')); // Cadena sin la fecha        
        this.observacionesArrayFormat = new ObservacionesRespuestaFormat();
        this.observacionesArrayFormat.fecha = cadenaFecha.slice(value.indexOf(" ")).trim(); // Cadena con solo fecha, sin espacios
        this.observacionesArrayFormat.usuario = cadenaParcial.substring(9, cadenaParcial.indexOf(":")).trim(); // Cadena con solo nombre de usuario, sin espacios
        this.observacionesArrayFormat.observacion = cadenaParcial.slice(cadenaParcial.indexOf(":") + 2).trim(); // Cadena con solo observaciones, sin espacios
        this.observacionesFinal.push(this.observacionesArrayFormat);
      }
     
    }
    this.prospecto.Estado_Prospecto_Desc = String(this.prospecto.Estado_Prospecto_Desc).toUpperCase();
    this.formularioProspecto.controls['Ruc_Adquirente'].setValue(this.prospecto.Ruc_Adquirente);
    this.formularioProspecto.controls['Ruc_Proveedor'].setValue(this.prospecto.Ruc_Proveedor);
    this.formularioProspecto.controls['Estado'].setValue(this.prospecto.Estado_Prospecto_Desc);
    this.formularioProspecto.controls['Nombre_Usuario_Riesgo'].setValue(this.prospecto.Nombre_Usuario_Comercial);
  }

  CerrarPopUp() {
    this.cerrarProspectoDetalle.emit();
  }

}